import { Pipe, PipeTransform } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';

@Pipe({
  name: 'formControlRawValue',
  pure: false,
})
export class FormControlRawValuePipe implements PipeTransform {
  transform(control: FormGroup): any;
  transform(control: FormArray): any[];
  transform(control: FormGroup | FormArray): any | any[] {
    return control.getRawValue();
  }
}
